import * as React from "react";
import { Card } from "components/common";
import { isLogEvidence } from "security-app/components/Investigations/Details/TimelineSegment/Utils";
import EvidenceFallbackCard from "security-app/components/Investigations/Details/TimelineSegment/EvidenceOverview/EvidenceFallbackCard";
import { evidenceCardId } from "./EvidenceCardFoundation";
import EvidenceLogCard from "./EvidenceLogCard";
import EvidenceEventCard from "./EvidenceEventCard";
const EvidenceCard = ({
  evidence,
  isInView,
  onShowSimilar,
  onResetShowSimilar,
  similarFieldsFilter,
  hasMessageStreamAccess,
  hasEventsStreamAccess
}) => {
  const sharedProps = {
    onResetShowSimilar,
    onShowSimilar,
    similarFieldsFilter
  };
  return /* @__PURE__ */ React.createElement(Card, { padding: "sm", id: evidenceCardId(evidence.id), tabIndex: 0 }, isInView && /* @__PURE__ */ React.createElement(React.Fragment, null, (() => {
    if (isLogEvidence(evidence)) {
      return hasMessageStreamAccess ? /* @__PURE__ */ React.createElement(EvidenceLogCard, { ...sharedProps, evidence }) : /* @__PURE__ */ React.createElement(EvidenceFallbackCard, { evidence });
    }
    return hasEventsStreamAccess ? /* @__PURE__ */ React.createElement(EvidenceEventCard, { ...sharedProps, evidence }) : /* @__PURE__ */ React.createElement(EvidenceFallbackCard, { evidence });
  })()));
};
export default EvidenceCard;
